import { render, staticRenderFns } from "./Modal2.vue?vue&type=template&id=49b5b19a&scoped=true&"
var script = {}
import style0 from "./Modal2.vue?vue&type=style&index=0&id=49b5b19a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b5b19a",
  null
  
)

export default component.exports